<template>
<div class="main home">
    <div class="home-box">
        <h1>角色管理</h1>
        <div class="home-content">
            <search-item :searchInfo.sync="info" @searchList="searchList" @addJS="addJS"></search-item>
            <!-- 表格 -->
            <div class="table_container" style="margin-top:10px;">
                <el-table border :data="tableData" stripe v-loading="tableLoading" style="width: 100%" align='center'>
                    <el-table-column prop="roleName" label="角色名称" align='center'>
                    </el-table-column>
                    <el-table-column prop="createTime" label="添加时间" align='center'>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleUpdate(scope.row)" :disabled="!scope.row.editStatus" type="text" size="small">修改</el-button>
                            <!-- <el-button type="text" size="small" :disabled="!scope.row.editStatus" @click="del(scope.row)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :paginationInfo="paginationInfo" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
            </div>
        </div>
    </div>
    <el-dialog :modal-append-to-body='false' title="添加/修改角色" :visible.sync="showDialog" width="40%">
        <el-form ref="form" label-width="80px">
            <el-form-item label="角色名称">
                <el-input v-model="jsData.roleName"></el-input>
            </el-form-item>
            <el-form-item label="权限" required>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedMenus" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="menu in menuItems" :label="menu" :key="menu">{{menu}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" round @click="onSubmit">提交</el-button>
                <el-button round @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import Pagination from "@/components/pagination";
import SearchItem from "./searchItem";
export default {
    data() {
        return {
            // 表格loading
            tableLoading: true,
            tableData: [], //表格数据
            paginationInfo: {
                pageIndex: 1, // 当前位于哪页
                pageTotal: 0, //表格总页数
                pageSize: 10, //每页显示条数
                pageSizes: [5, 10, 15, 20], //每页显示个数选择器的选项设置
                layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
            },
            pidList: [],
            centerDialogVisible: false,
            registerId: "",
            info: {
                name: ""
            },
            activeName: '0',
            showDialog: false,
            jsData: {
                roleName: '',
                menuCode:[]
            },
            editState: false,
            checkAll: false,
            menusData:[],
            menuOptions:[],
            checkedMenus: [],
            menuItems: [],
            isIndeterminate: false
        }
    },
    mounted() {
        let that = this
        this.getJSList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
        this.getMenu()
    },
    methods: {
        //  获取表格信息
        getJSList(currpage, pageSize, info) {
            console.log(info)
            this.tableLoading = true;
            let params = {
                pageNumber: currpage,
                pageSize: pageSize,
                keyWords: info ? info.name : ''
            }
            this.tableData = []
            console.log(params)
            this.$api.getJSList(params).then(res => {
                console.log('000', res)
                this.tableLoading = false;
                if (res && res.status == "OK") {
                    this.paginationInfo.pageTotal = parseInt(res.data.total)
                    this.paginationInfo.pageIndex = res.data.pageNum
                    this.tableData = res.data.pageList
                } else {
                    this.tableLoading = false;
                    this.$message.error(res.errorMsg)
                }
            }).catch(error => {
                console.log(error)
                this.tableLoading = false;
            })
        },
        searchList(e) {
            console.log(e)
            this.info = e
            this.getJSList(1, this.paginationInfo.pageSize, e)
        },
        // 上下分页
        handleCurrentChange(val) {
            // console.log('上下分页',val)
            let that = this
            this.paginationInfo.pageIndex = val
            this.getJSList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
        },
        // 每页显示多少条
        handleSizeChange(val) {
            // console.log('每页显示多少条',val)
            let that = this
            this.paginationInfo.pageSize = val
            this.getJSList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
        },
        submitDialog(e) {
            this.registerId = e.registerId
            this.centerDialogVisible = true
        },
        onSubmit() {
            let that = this
            if (this.jsData.roleName.toString().trim() == "") {
                this.$message.warning('请添加角色名称')
                return
            }
            if (this.checkedMenus.length < 1) {
                this.$message.warning('请选择菜单权限')
                return
            }
            this.jsData.menuCode = []
            this.checkedMenus.map(n => {
                this.jsData.menuCode.push(this.menusData.filter(i => i.menuName === n)[0].menuCode)
            })
            if (this.editState) {
                this.$api.updateJS(this.jsData).then(res => {
                    console.log(res)
                    if (res.status == "OK") {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.showDialog = false
                        this.jsData.xh = null
                        this.jsData.rsName = ""
                        this.jsData.id = null
                        this.editState = false
                        this.getJSList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
                    } else {
                        this.$message.error(res.errorMsg)
                    }
                })
            } else {
                this.$api.saveJS(this.jsData).then(res => {
                    console.log(res)
                    if (res.status == "OK") {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.showDialog = false
                        this.jsData.xh = null
                        this.jsData.rsName = ""
                        this.editState = false
                        this.getJSList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
                    } else {
                        this.$message.error(res.errorMsg)
                    }
                })
            }
        },
        handleUpdate(e) {
            console.log(e)
            this.checkedMenus = []
            this.showDialog = true
            this.jsData = {
                roleName: e.roleName,
                menuCode: e.menuCode,
                roleId: e.roleId
            }
            e.menuCode.map(item => {
                this.checkedMenus.push(this.menusData.filter(i => i.menuCode === item)[0].menuName)
            })
            this.isIndeterminate = e.menuCode.length > 0 ? true : false
            this.editState = true
        },
        addJS() {
            this.jsData = {
                roleName:'',
                menuCode:[]
            }
            this.showDialog = true
        },
        close() {
            this.showDialog = false
        },
        del(e) {
            console.log(e)
            let that = this
            this.$confirm('确定要删除该权限组吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delJS({
                    roleId: e.roleId
                }).then(res => {
                    if (res.status == "OK") {
                        this.getJSList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        });
                    }
                })
            }).catch(() => {});
        },
        handleCheckAllChange(val) {
            console.log(val)
            this.checkedMenus = val ? val : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.menuItems.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.menuItems.length;
        },
        getMenu(){
            this.$api.getJSMenu({}).then(res => {
                console.log("@@!!!!!",res)
                this.menuOptions = []
                this.menusData = res.data
                res.data.map(item => {
                    this.menuOptions.push(item.menuName)
                })
                this.menuItems = this.menuOptions
                console.log("###",this.menuOptions)
            })
        }
    },
    components: {
        Pagination,
        SearchItem
    },
    filters: {
        icCardFilters(val) {
            if (val) {
                if (val.length > 10) {
                    return val.substring(0, 6) + "****" + val.substring(val.length - 4)
                } else {
                    return val
                }
            } else {
                return val
            }
        }
    }
}
</script>

<style>
/* 标题 */
.menu .title1 img {
    top: 22px;
}

.menu .title1 h3 {
    font-size: 20px;
    margin-top: -14px;
}

/* 分页 */
.el-pagination button,
.el-pagination span:not([class*=suffix]) {
    padding: 0 10px;
}

.home .block-title {
    width: 100%;
    padding: 0 0 28px 20px;
    display: flex;
    align-items: center;
}

.home .block-title h3 {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
}

.home .a-text {
    text-decoration: underline;
    color: #1e61ce;
}

.home .block-title .btn {
    width: 180px;
    height: 35px;
    background-color: #1e61ce;
    border-radius: 20px;
    margin-left: 20px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    padding: 0;
}

.home .btn span {
    font-size: 16px !important;
    color: #fff !important;
}

.home .block-title span {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #63717A;
}

.home .top {
    width: 100%;
    padding: 0 0 10px 0;
    border-radius: 10px;
    background: #fefefe;
}

.home .top .title {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
    border-bottom: 1px solid #f2f3f5;
}

.home .el-col {
    border-radius: 10px;
}

.home .grid-content {
    border-radius: 10px;
    /* min-height: 36px; */
}

.home .leftInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}

.home .leftInfo .headPic {
    width: 165px;
    height: 165px;
    border-radius: 100%;
    border: 8px solid #fff;
    position: relative;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0px 12px 30px 0px rgba(6, 37, 117, 0.12);
}

.home .leftInfo .headPic img {
    width: 100%;

}

.home .rightInfo {
    margin-top: 10px;
    padding-right: 10px;
}

.home .rightInfo .name-text {

    margin-bottom: 20px;
    font-family: PingFangSC-Semibold;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
}

.home .rightInfo .info-text img {
    width: 26px;
    height: 26px;
    margin-right: 20px;
}

.home .rightInfo .info-text {
    margin-bottom: 20px;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    letter-spacing: 0px;
    color: #63717a;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    text-align: left
}

.home .rightInfo .info-text h1 {
    font-size: 20px;
    font-weight: 600;
    font-family: PingFangSC-Medium;
    color: #2d3039;
    margin-left: 10px;
    display: block;
    font-size: 90.5%;
}

.home .middle {
    width: 100%;
    border-radius: 10px;
}

.home .middle .grid-content {
    background: #fff
}

.home .title1 {
    width: 100%;
    display: flex;
    padding: 0 20px 20px 20px;
    align-items: center;
    margin-top: -10px;
    border-bottom: 1px solid #f2f3f5;
}

.home .title1 h3 {
    font-size: 20px;
    margin-top: -10px;
}

.home .title1 img {
    position: relative;
    top: 18px;
    margin-right: 10px;
}

.home .ajs-Title {
    margin-left: 20px;
}

.home .ajs {
    margin-left: 20px;
    color: #0033cf;
}

.home .left-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    /* border-right: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8; */
}

.home .right-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
}

.home .main-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
}

/*案件办理天数 标签统计 hmm 090403*/
.home .labelModule {
    background: #F2F5FA;
    border: 1px solid #D6E0F0;
    border-radius: 10px;
    display: inline-block;
    width: 100%;
    padding: 20px;
}

.home .labelModule:first-child {
    margin-bottom: 20px;
}

.home .labelModule ul li {
    width: 100%;
    font-size: 16px;
    color: #63717A;
    text-align: center
}

.home .labelModule ul li:first-child {
    margin-bottom: 10px;
}

.home .labelModule ul li font {
    font-size: 41px;
    color: #2D3039;
}

/*公共部分 hmm*/
.p20 {
    padding: 20px;
}

.pb30 {
    padding-bottom: 30px;
}

/*办案类型 数据超出 显示样式 hmm 090404*/

.widthBig .labelModule {
    width: 49.2%;
}

.widthBig .labelModule:first-child {
    margin-bottom: 30px;
    margin-right: 20px;
}

.widthSmall {
    float: right;
}

.rs-block {
    width: 98%;
    height: 80px;
    text-align: right;
    line-height: 80px;
}
</style>
